module.exports = __webpack_public_path__ + "static/media/package_develop_android_app.c00834a6.svg";